<!--
create by melody on 2018/11/1
description:税率配置页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
		<div class="table-container">
			<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
			<el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
			<el-table
				ref="multipleTable"
				:data="tableData"
				stripe
				tooltip-effect="dark"
				style="width: 100%;margin: 24px 0"
				@select="handleSelect"
	            @select-all="handleSelectAll"
				>
				<el-table-column
					type="selection"
					width="35">
				</el-table-column>
				<el-table-column
					type="index"
					label="#">
				</el-table-column>
				<el-table-column
					prop="taxName"
					:label="$t('m.taxName')">
				</el-table-column>
				<el-table-column
					prop="taxType"
					:label="$t('m.taxType')">
				</el-table-column>
				<el-table-column
					prop="region"
					:label="$t('m.region')">
				</el-table-column>
				<el-table-column
					prop="deductible"
					:label="$t('m.deductible')">
				</el-table-column>
				<el-table-column
					prop="taxLogic"
					:label="$t('m.taxLogic')">
				</el-table-column>
				<el-table-column
					prop="taxRate"
                    :label="$t('m.taxRate')">
                    <template slot-scope="scope">
                        {{scope.row.taxRate + '%'}}
                    </template>
				</el-table-column>
				<el-table-column
					:label="$t('m.operation')"
					align="right" width="150">
					<template slot-scope="scope">
						<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="hdp-uf">
                <a href="./static/template/税率配置模板.xlsx">
				    <el-button type="primary" icon="el-icon-download"> {{$t('m.taxRateTemplate')}} </el-button>
                </a>
				<lap-upload-file uploadUrl="/config/taxRate/uploadedTaxRateFile" @successMethod="getDemoList()"></lap-upload-file>
			</div>
            <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
		</div>
		<!-- add Form -->
		<el-dialog
			:title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify'):''"
			:visible.sync="dialogVisible"
			v-if="dialogVisible"
			width="30%">
			<div style="margin-left: 10%">
				<el-form ref="form" :model="form" :rules="rules">
					<el-form-item :label="$t('m.taxName')" prop="taxName" label-width="100px">
						<el-input v-model.trim="form.taxName" :maxlength="40" style="width:80%;"></el-input>
					</el-form-item>
					<el-form-item :label="$t('m.taxType')" prop="taxType" label-width="100px">
						<el-select v-model="form.taxType" style="width:80%;">
							<el-option v-for="(item,index) in taxTypeList" :key="index" :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.region')" prop="region" label-width="100px">
                        <el-select filterable v-model="form.region" style="width:80%;">
                            <el-option v-for="(item, index) in regionList" :key="index" :label="item.label" :value="item.label"></el-option>
                        </el-select>
					</el-form-item>
					<el-form-item :label="$t('m.deductible')" prop="deductible" label-width="100px">
						<el-select v-model="form.deductible" style="width:80%;">
							<el-option v-for="(item, index) in deductibleList" :key="index" :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.taxLogic')" prop="taxLogic" label-width="100px">
						<el-select v-model="form.taxLogic" style="width:80%;">
							<el-option v-for="(item, index) in taxLogicList" :key="index" :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.taxRate')" prop="taxRate" label-width="100px">
						<el-input v-model.trim="form.taxRate"  :maxlength="20" style="width:80%;">
                            <template slot="append">%</template>                  
                        </el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.TAX_RATE')
			},
			searchParam: {
				pageNum: 1,
				pageSize: 10
			},
			form: {     //弹框内容
                taxRateId: '',
                taxName: '',
                taxType: '',
                region: '',
                deductible: true,
                taxLogic: '',
                taxRate: ''
            },
            rules: this.$ruleApi.getRule('taxRate'),
            tableData: [],  //表数据
            total: 0,   //总数
            dialogVisible: false,   //控制弹框显示与隐藏
            taxTypeList: [],
            deductibleList: [],
            taxLogicList: [],
            operateType: '',    //操作类型 add新增 modify修改 view查看
            deleteDemoIdArr: [],
            addDisable: false
		}
	},
	methods: {
		getDemoList() {
            this.$commonFunc.commonRequest('get', '/config/taxRate/getTaxRateList', 'getMenuList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.$commonFunc.commonRequest('post', '/config/taxRate/addTaxRate', 'addTaxRate', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'))
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/config/taxRate/updateTaxRate', 'modifyTaxRate', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            this.dialogVisible = true
            //如果操作已有数据
            if(row) {
                this.form["taxRateId"] = row.taxRateId
                this.form["taxName"] = row.taxName
                this.form["taxType"] = row.taxType
                this.form["region"] = row.region
                this.form["deductible"] = row.deductible
                this.form["taxLogic"] = row.taxLogic
                this.form["taxRate"] = row.taxRate
            	// this.form = JSON.parse(JSON.stringify(row))
            } else {
                this.form = {
	                taxName: '',
	                taxType: '',
	                region: '',
	                deductible: '',
	                taxLogic: '',
	                taxRate: ''
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
            if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.taxRateId)
                } else {
                	demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('post', '/config/taxRate/batchDeleteTaxRate', 'deleteTaxRate', {taxRateIds: demoIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'))
                    this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].taxRateId)
                }
            }
        },
        //处理全选
        handleSelectAll(selection) {
            this.deleteDemoIdArr = []
            if(selection.length) {
                for(var i = 0; i < selection.length; i++) {
                    this.deleteDemoIdArr.push(selection[i].taxRateId)
                }
            }
        },
	},
	async mounted() {
		this.getDemoList()
		this.taxTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj.TAX_TYPE) 
		this.deductibleList = await this.$commonFunc.getValueSetList(this.$valueSetObj.DEDUCTIBLE)
		this.taxLogicList = await this.$commonFunc.getValueSetList(this.$valueSetObj.TAX_LOGIC)
        this.regionList = await this.$commonFunc.getValueSetList(this.$valueSetObj.REGION)
	}
}
</script>
<style scoped lang="scss">
.search-container {
	background: #ffffff;
	padding: 20px;
}
.el-select {
	width: 300px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.block {
	text-align: right;
}
.file-btn{
	margin-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/TaxRate.vue